import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { storage } from './lib/storage';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// Apply display preferences before the first paint so we never render an
// unwanted transition or reflow rows from comfortable to compact. The
// appearance settings re-apply both live.
const bootPrefs = storage.getPrefs();
document.documentElement.dataset.animations = bootPrefs.animations ? 'on' : 'off';
document.documentElement.dataset.density = bootPrefs.density ?? 'comfortable';

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
